module.exports = __webpack_public_path__ + "img/cf.783b2803.jpg";